/* src/app/global/components/global-header/global-header.component.scss */
:host {
  font-size: 1.4rem;
  height: 60px;
  min-height: 60px;
  width: 100%;
}
/*# sourceMappingURL=global-header.component.css.map */
